type ComposerKeyboardEvent = {
  key: string;
  shiftKey: boolean;
  altKey: boolean;
  isComposing: boolean;
};

export const shouldSubmitComposer = ({
  key,
  shiftKey,
  altKey,
  isComposing,
}: ComposerKeyboardEvent) =>
  key === 'Enter' && !shiftKey && !altKey && !isComposing;

export const shouldInsertComposerNewline = ({
  key,
  altKey,
  isComposing,
}: ComposerKeyboardEvent) => key === 'Enter' && altKey && !isComposing;
